import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {ErrorType} from "config/errors";
import {ErrorPayload, supportWebformApi} from "webform/api";
import {SupportContactFormService} from "webform/gen/supportContactForm";

export const submitFormAction = createAsyncThunk(
    "webform/form/submitForm",
    async (req: SupportContactFormService.SubmitFormRequest, {rejectWithValue}) => {
        try {
            return await supportWebformApi.submitForm(req);
        } catch (err) {
            return rejectWithValue(err);
        }
    },
);

interface SubmitFormState {
    error?: ErrorType;
    isLoading: boolean;
    isSubmitted: boolean;
    fieldsWithError: string[];
}

export const initialState: SubmitFormState = {
    isLoading: false,
    isSubmitted: false,
    fieldsWithError: [],
};

export const slice = createSlice({
    name: "submitForm",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(submitFormAction.fulfilled, (state) => {
            state.isLoading = false;
            state.isSubmitted = true;
        });
        builder.addCase(submitFormAction.rejected, (state, action) => {
            const {response} = action.payload as ErrorPayload;
            if (response?.validation_errors?.length) {
                state.fieldsWithError = response.validation_errors.map((err) => err.property);
            } else {
                state.error = ErrorType.SUBMIT_FORM_FAILED;
            }
            state.isLoading = false;
        });
        builder.addCase(submitFormAction.pending, (state) => {
            state.error = undefined;
            state.isLoading = true;
            state.isSubmitted = false;
        });
    },
});

export default slice.reducer;
